import React from "react";

import ReactTooltip from "react-tooltip";
import { Alignment } from "../../types/system/Layout";

import "./Toggle.scss";

interface ToggleProps {
    id?: string;
    onLabel?: string;
    offLabel?: string;
    value?: boolean;
    disabled?: boolean;
    className?: string;
    tooltip?: string | null;
    tooltipPlace?: string;
    alignment?: Alignment;
    onChange?: (value?: boolean) => void;
}

interface ToggleState {
    ref: React.RefObject<HTMLInputElement>;
}

class Toggle extends React.Component<ToggleProps, ToggleState> {
    state: ToggleState = {
        ref: React.createRef<HTMLInputElement>(),
    };

    componentDidMount(): void {
        ReactTooltip.rebuild();
    }

    focus() {
        this.state.ref.current?.focus();
    }

    render(): React.ReactNode {
        let classes = "toggle";

        if (this.props.className) classes += " " + this.props.className;

        switch (this.props.alignment) {
            case Alignment.Left:
                classes += " left";
                break;
            case Alignment.Right:
                classes += " right";
                break;
            case Alignment.Center:
                classes += " center";
                break;
        }

        return (
            <label
                className={classes}
                data-html={true}
                data-tip={this.props.tooltip}
                data-place={this.props.tooltipPlace}>
                <input
                    id={this.props.id}
                    ref={this.state.ref}
                    type="checkbox"
                    checked={this.props.value ?? false}
                    disabled={this.props.disabled === true}
                    onChange={
                        this.props.onChange
                            ? () => this.props.onChange?.(!this.props.value)
                            : undefined
                    }
                />
                <span className="slider">
                    {(this.props.value && this.props.onLabel) ||
                    (!this.props.value && this.props.offLabel) ? (
                        <span className="label">
                            {this.props.value
                                ? this.props.onLabel
                                : this.props.offLabel}
                        </span>
                    ) : null}
                </span>
            </label>
        );
    }
}

export default Toggle;
